import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "saving-overlay"
}
const _hoisted_2 = {
  class: "card",
  style: {"max-width":"800px"}
}
const _hoisted_3 = {
  class: "grid",
  style: {"grid-template-columns":"repeat(auto-fit, minmax(220px, 1fr))","gap":"14px"}
}
const _hoisted_4 = { class: "input-field" }
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "input-field" }
const _hoisted_7 = { class: "input-field" }
const _hoisted_8 = { class: "input-field" }
const _hoisted_9 = { class: "image-grid" }
const _hoisted_10 = ["src"]
const _hoisted_11 = {
  key: 0,
  class: "subtitle",
  style: {"color":"#a54b2a"}
}
const _hoisted_12 = { class: "actions" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = ["disabled"]
const _hoisted_15 = ["disabled"]
const _hoisted_16 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NoticeModal = _resolveComponent("NoticeModal")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["page", { embedded: _ctx.embedded }])
  }, [
    (_ctx.isSaving)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[11] || (_cache[11] = [
          _createElementVNode("div", { class: "saving-card" }, "Salvando dados...", -1)
        ]))]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _cache[16] || (_cache[16] = _createElementVNode("div", { class: "card-header" }, [
        _createElementVNode("div", null, [
          _createElementVNode("h1", { class: "title" }, "Relatorio de Ocorrido"),
          _createElementVNode("p", { class: "subtitle" }, "Descricao do ocorrido e evidencias.")
        ]),
        _createElementVNode("span", { class: "pill" }, "Seguranca")
      ], -1)),
      _createElementVNode("form", {
        class: "form-grid",
        onSubmit: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[12] || (_cache[12] = _createElementVNode("label", { for: "attraction" }, "Projeto", -1)),
            _withDirectives(_createElementVNode("select", {
              id: "attraction",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.attraction) = $event))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projectOptions, (item) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: item,
                  value: item
                }, _toDisplayString(item), 9, _hoisted_5))
              }), 128))
            ], 512), [
              [_vModelSelect, _ctx.attraction]
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _cache[13] || (_cache[13] = _createElementVNode("label", { for: "reportDate" }, "Data", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "reportDate",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.reportDate) = $event)),
              type: "date"
            }, null, 512), [
              [_vModelText, _ctx.reportDate]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _cache[14] || (_cache[14] = _createElementVNode("label", { for: "description" }, "Descricao do ocorrido", -1)),
          _withDirectives(_createElementVNode("textarea", {
            id: "description",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.description) = $event)),
            rows: "4",
            placeholder: "Descreva o ocorrido"
          }, null, 512), [
            [_vModelText, _ctx.description]
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _cache[15] || (_cache[15] = _createElementVNode("label", null, "Imagem", -1)),
          _createElementVNode("div", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images, (img, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: `img-${index}`,
                class: "image-preview"
              }, [
                _createElementVNode("img", {
                  src: _ctx.resolveUrl(img),
                  alt: "preview"
                }, null, 8, _hoisted_10)
              ]))
            }), 128)),
            (_ctx.images.length < 5)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "image-add",
                  type: "button",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.triggerImageInput && _ctx.triggerImageInput(...args)))
                }, "+"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("input", {
            id: "occurrence-file",
            class: "hidden-input",
            type: "file",
            accept: "image/*",
            multiple: "",
            onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onImagesSelected && _ctx.onImagesSelected(...args)))
          }, null, 32)
        ]),
        (_ctx.error)
          ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(_ctx.error), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("button", {
            class: "btn btn-secondary",
            type: "button",
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.saveDraft && _ctx.saveDraft(...args))),
            disabled: _ctx.isSaving
          }, " Salvar rascunho ", 8, _hoisted_13),
          _createElementVNode("button", {
            class: "btn btn-primary",
            type: "button",
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.send && _ctx.send(...args))),
            disabled: _ctx.isSaving
          }, " Enviar ", 8, _hoisted_14),
          (_ctx.isEdit)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "btn btn-accent",
                type: "button",
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.remove && _ctx.remove(...args))),
                disabled: _ctx.isSaving
              }, " Excluir ", 8, _hoisted_15))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            class: "btn btn-ghost",
            type: "button",
            onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args))),
            disabled: _ctx.isSaving
          }, " Cancelar ", 8, _hoisted_16)
        ])
      ], 32)
    ]),
    _createVNode(_component_NoticeModal, {
      open: _ctx.noticeOpen,
      title: _ctx.noticeMessage,
      "button-text": "Entendi",
      onClose: _cache[10] || (_cache[10] = ($event: any) => (_ctx.noticeOpen = false))
    }, null, 8, ["open", "title"])
  ], 2))
}